import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCheckCircle } = FiIcons;

export default function BookingModal({ isOpen, onClose, title, price }) {
  const [step, setStep] = useState(1);

  const handleNext = () => {
    if (step < 2) setStep(step + 1);
    else {
      // Simulate API call/processing
      setStep(3);
      setTimeout(() => {
        onClose();
        setStep(1);
      }, 3000);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-brand-darkRed/60 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-white dark:bg-brand-slate rounded-2xl shadow-xl w-full max-w-md overflow-hidden"
          >
            <div className="flex justify-between items-center p-6 border-b border-sand-100">
              <h3 className=" font-semibold text-xl text-[#333] dark:text-[#fff]">Secure Checkout</h3>
              <button onClick={onClose} className="text-[#333] dark:text-[#fff] hover:text-[#333] dark:text-[#fff] transition-colors">
                <SafeIcon icon={FiX} className="w-6 h-6" />
              </button>
            </div>

            <div className="p-6">
              {step === 1 && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                  <div className="mb-6 bg-sand-50 dark:bg-brand-slate/80 p-4 rounded-lg">
                    <p className="text-sm text-[#333] dark:text-[#fff] mb-1">You are booking:</p>
                    <p className="font-semibold text-[#333] dark:text-[#fff]">{title}</p>
                    <p className="text-[#333] dark:text-[#fff] font-medium mt-2">${price} USD</p>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-[#333] dark:text-[#fff] mb-1">Full Name</label>
                      <input type="text" className="w-full px-4 py-2 border border-sand-200 rounded-lg focus:ring-2 focus:ring-brand-rose focus:border-brand-rose outline-none" placeholder="Jane Doe" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-[#333] dark:text-[#fff] mb-1">Email Address</label>
                      <input type="email" className="w-full px-4 py-2 border border-sand-200 rounded-lg focus:ring-2 focus:ring-brand-rose focus:border-brand-rose outline-none" placeholder="jane@example.com" />
                    </div>
                  </div>
                  <button onClick={handleNext} className="w-full mt-8 px-10 py-4 bg-brand-rose text-white dark:text-white rounded-full font-medium text-center hover:brightness-110 transition-all shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray hover:translate-y-1 hover:shadow-none flex items-center justify-center gap-2">
                    Continue to Payment
                  </button>
                </motion.div>
              )}

              {step === 2 && (
                <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-[#333] dark:text-[#fff] mb-1">Card Details</label>
                      <div className="p-4 border border-sand-200 rounded-lg bg-gray-50 dark:bg-brand-slate flex items-center justify-center text-sm text-[#333] dark:text-[#fff]">
                        [ Stripe / Payment Element Simulation ]
                      </div>
                    </div>
                  </div>
                  <div className="flex space-x-3 mt-8">
                    <button onClick={() => setStep(1)} className="px-10 py-4 bg-brand-rose text-white dark:text-white rounded-full font-medium text-center hover:brightness-110 transition-all shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray hover:translate-y-1 hover:shadow-none flex items-center justify-center gap-2">
                      Back
                    </button>
                    <button onClick={handleNext} className="flex-1 px-10 py-4 bg-brand-rose text-white dark:text-white rounded-full font-medium text-center hover:brightness-110 transition-all shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray hover:translate-y-1 hover:shadow-none flex items-center justify-center gap-2">
                      Pay ${price}
                    </button>
                  </div>
                </motion.div>
              )}

              {step === 3 && (
                <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-8">
                  <SafeIcon icon={FiCheckCircle} className="w-16 h-16 text-[#333] dark:text-[#fff] mx-auto mb-4" />
                  <h4 className=" font-semibold text-2xl text-[#333] dark:text-[#fff] mb-2">Booking Confirmed!</h4>
                  <p className="text-[#333] dark:text-[#fff]">A confirmation email with access details has been sent to your inbox.</p>
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}